import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const PHONE = "15039917412"; // (503) 991-7412 — US country code 1

export default function WhatsAppButton() {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useLang();
  const { pathname } = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setIsMounted(true), 800);
    return () => clearTimeout(t);
  }, []);

  const message = t(
    "Hi! I'm interested in your remodeling services. Could you give me more info?",
    "¡Hola! Me interesan sus servicios de remodelación. ¿Me podrían dar más información?"
  );
  if (pathname.startsWith("/admin")) return null;
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${isMounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      data-testid="whatsapp-floating"
    >
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("Chat with Finix Terra on WhatsApp", "Escríbale a Finix Terra por WhatsApp")}
        data-testid="whatsapp-btn"
        className="relative group"
      >
        <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-lg transition-all duration-200 hover:scale-105 active:scale-95">
          <svg viewBox="0 0 32 32" className="w-6 h-6 fill-white" aria-hidden="true">
            <path d="M16.003 3C9.376 3 4 8.376 4 15.003c0 2.27.62 4.487 1.798 6.43L4 29l7.74-1.756a11.95 11.95 0 005.263 1.234h.005c6.627 0 12.003-5.376 12.003-12.003 0-3.207-1.249-6.222-3.515-8.49A11.928 11.928 0 0016.003 3zm0 21.97a9.96 9.96 0 01-5.077-1.388l-.364-.216-4.59 1.041 1.064-4.474-.237-.376a9.967 9.967 0 01-1.529-5.314c0-5.518 4.49-10.008 10.01-10.008 2.673 0 5.187 1.041 7.077 2.93a9.94 9.94 0 012.93 7.078c0 5.519-4.491 10.008-10.011 10.008zm5.482-7.491c-.301-.151-1.778-.876-2.054-.977-.275-.1-.475-.15-.674.151-.2.301-.776.977-.951 1.177-.175.2-.351.225-.652.075-.301-.15-1.27-.467-2.42-1.491-.894-.797-1.498-1.781-1.673-2.082-.175-.301-.019-.464.131-.614.135-.135.301-.351.451-.526.151-.175.2-.301.301-.501.1-.2.05-.376-.025-.526-.075-.151-.674-1.625-.924-2.226-.243-.583-.49-.504-.674-.513l-.575-.01a1.103 1.103 0 00-.802.376c-.275.301-1.052 1.027-1.052 2.503 0 1.476 1.077 2.903 1.227 3.103.151.2 2.121 3.235 5.137 4.537.718.31 1.278.495 1.715.633.72.229 1.376.197 1.894.12.578-.087 1.778-.727 2.029-1.428.251-.701.251-1.302.176-1.428-.075-.125-.275-.2-.576-.351z"/>
          </svg>
        </span>
      </a>
    </div>
  );
}
